module.exports = __webpack_public_path__ + "img/null_data.2819112a.png";